import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "./primitives";
import { SERVICES } from "../data";

export default function ServicesMarquee() {
  return (
    <section data-testid="services-marquee" className="relative z-10 py-10 overflow-hidden">
      <Marquee speed={55} gradient={false} direction="right">
        {SERVICES.concat(SERVICES).map((s, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-5xl md:text-7xl font-[200] text-white/25 hover:text-gold transition-colors duration-500 px-8">
              {s.title}
            </span>
            <Star size={16} className="text-gold/60 mx-4" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
